import { Fragment } from 'react';
import { KeenIcon } from '@/components';
import { toAbsoluteUrl } from '@/utils/Assets';
import { CommonHexagonBadge } from '@/partials/common';

interface IntroProps {
    mode: "create" | "addSource";
}

const Intro: React.FC<IntroProps> = ({ mode }) => {
    // Determine header and description based on the mode for a company.
    const headerText =
        mode === "addSource"
            ? "Adding a Source to a Company is as Easy as This!"
            : "Adding a Company is as Easy as This!";

    const descriptionText =
        mode === "addSource"
            ? `Easily add a new source to your company's profile using various methods. You can upload a document, paste plain text with the source details, or even include a link from your website or other platforms. Buddy will process the information, structure it into a detailed profile, and enhance your company's data. You can also import source details directly from popular ATS platforms and other HR or recruiting tools, making it seamless to gather and manage company sources from multiple platforms!`
            : `Easily add a company to Buddy using various methods. You can upload a company description or profile, paste plain text with the company details, or even include a link to your company website or other platforms. Buddy will process the information, structure it into a detailed company profile, and streamline candidate matching. You can also import company details directly from popular ATS platforms and other HR or recruiting tools, making it effortless to gather and manage company information from multiple sources!`;

    return (
        <Fragment>
            <style>
                {`
          .upgrade-bg {
            background-image: url('${toAbsoluteUrl('/media/images/2600x1200/bg-5.png')}');
          }
          .dark .upgrade-bg {
            background-image: url('${toAbsoluteUrl('/media/images/2600x1200/bg-5-dark.png')}');
          }
        `}
            </style>

            <div className="card rounded-xl">
                <div className="flex items-center justify-between grow gap-2 p-5 [background-position:121%_41%] bg-no-repeat bg-[length:660px_310px] upgrade-bg">
                    <div className="flex items-center gap-4">
                        <CommonHexagonBadge
                            stroke="stroke-success-clarity"
                            fill="fill-success-light"
                            size="size-[50px]"
                            badge={<KeenIcon icon="information-4" className="text-xl text-success" />}
                        />

                        <div className="flex flex-col gap-1.5">
                            <div className="flex items-center gap-2.5">
                                {headerText}
                            </div>

                            <div className="text-2sm text-gray-800">
                                {descriptionText}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
};

export { Intro };
